import { TableCell, TableRow } from '@mui/material';
import { formatPrice } from '../../../../../services/util/prices/formatPrice';
import { Streamingpackage } from '../../../../../interfaces/StreamingProvider.interface';
import React from 'react';
import { getProviderData } from '../../../../../services/util/streamingpackage/getProviderImageAndUrl';
import CustomTooltip from '../../../../shared/tooltip/CustomTooltip';

type PriceTableRowProps = {
  provider: Streamingpackage;
  validMonthPrice: number | null;
  validYearPrice: number | null;
  greenPrice: number | null;
  isShowCheapeastActive: boolean;
  showWithIcons: boolean;
};
const PriceTableRow: React.FC<PriceTableRowProps> = ({
  provider,
  validMonthPrice,
  greenPrice,
  isShowCheapeastActive,
  validYearPrice,
  showWithIcons,
}) => {
  return (
    <TableRow key={provider.id}>
      <TableCell>
        {showWithIcons ? (
          <a
            href={getProviderData(provider.name)?.url}
            target="_blank"
            rel="noopener noreferrer"
          >
            <CustomTooltip
              icon={
                <img
                  src={getProviderData(provider.name)?.image}
                  style={{
                    borderRadius: '5px',
                    minWidth: '50px',
                    maxWidth: '50px',
                  }}
                  alt="Providerlogo"
                />
              }
              title={provider.name}
            />
          </a>
        ) : (
          <></>
        )}

        {provider.name}
      </TableCell>
      <TableCell
        sx={{
          color:
            validMonthPrice === greenPrice && isShowCheapeastActive
              ? '#5E81F4'
              : 'inherit',
        }}
      >
        {provider.monthly_price_cents === 0
          ? 'free'
          : !validMonthPrice
            ? '-'
            : `${formatPrice(provider.monthly_price_cents)} per Month`}
      </TableCell>

      <TableCell
        sx={{
          color:
            validYearPrice === greenPrice && isShowCheapeastActive
              ? '#5E81F4'
              : 'inherit',
        }}
      >
        {provider.monthly_price_yearly_subscription_in_cents === 0
          ? 'free'
          : !validYearPrice
            ? '-'
            : `${formatPrice(provider.monthly_price_yearly_subscription_in_cents)} per Month`}
      </TableCell>
    </TableRow>
  );
};
export default PriceTableRow;
